<div class="list-content">
  <div class="filter-row">
    <mat-form-field class="filter-item search-input">
      <mat-label>Search by name</mat-label>
      <fa-icon matPrefix [icon]="['fas', 'magnifying-glass']"></fa-icon>
      <input
        data-test-id="SEARCH_FILTER_INPUT"
        matInput
        (keyup.enter)="filters.search = $event.target.value; reloadData()"
      />
    </mat-form-field>
  </div>
  <div class="table-container">
    <app-event-category-list-table
      [dataArr]="eventCategories"
      [isLoading]="isLoading"
      [tableFilters]="getTableFilters"
      (tableFiltersUpdated)="updateTableFilters($event)"
      (onEdit)="showCreateEditModal($event)"
      (onDelete)="showDeleteModal($event)"
    />
  </div>
</div>
